
import { withRouter, Prompt } from 'react-router'
import { Link, Switch, Route } from 'react-router-dom'
import React, { Component } from 'react'
import { CSSTransition } from "react-transition-group"
import { connect } from 'react-redux'
import { editEndpointList } from '../../actions/endpoints'
import { Formik } from 'formik'
import FormButtonPanel from '../utilities/FormButtonPanel'
import ReactQuill from 'react-quill';
import moment from 'moment'
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import _ from 'lodash'

class ReleaseNoteForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            endpoints: props.endpoints,
            isFetching: props.isFetching,
        }
    }

    breadCrumb() {
        let breadCrumb = window.location.href.split('/')
        return breadCrumb
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            endpoints: nextProps.endpoints,
            ACLEndpointList: nextProps.ACLEndpointList,
            isFetching: nextProps.isFetching
        })
    }

  

    render() {
        let {
            endpoints,
            isFetching
        } = this.state

        // Initialize an empty object
        let objProp = {}

        let releaseList
        let currentDate = moment().format("MM-DD-YYYY")
        let futureRelease
        let closestRelease
        let latestRelease
        let finalRelease

        // Initial values
        let initVal = Object.assign({}, { endpoints }, objProp)

             
        for (let n in endpoints) {
            if (endpoints[n].name === "releasenotes") {
               releaseList = endpoints[n].list
            } 
        }

     


        if(releaseList){
            for (let a in releaseList){
                
                releaseList[a].release_date = moment(releaseList[a].release_date).format('MM-DD-YYYY')

                let releaseDate = releaseList[a].release_date
     

                if(moment(releaseDate).diff(moment(currentDate),'days' )== 0 ){
                    //console.log("latestDiff",moment(releaseDate).diff(moment(currentDate),'days'  ))
                    latestRelease = releaseList[a]
                    
                }else if (moment(releaseDate).diff(moment(currentDate),'days' )< 0 ){
                    //console.log("futureDiff",moment(releaseDate).diff(moment(currentDate),'days'  ))
                    closestRelease = releaseList[a]
                    
                }else if (moment(releaseDate).diff(moment(currentDate),'days'  )> 0){
                    //console.log("futureDiff",moment(releaseDate).diff(moment(currentDate),'days'  ))
                    futureRelease = releaseList[a]
                }
            }
            console.log("closestRelease",closestRelease)
            console.log("latestRelease",latestRelease)
            console.log("futureRelease",futureRelease)

           
        }

        // if(!closestRelease && latestRelease   && !futureRelease){
        //     finalRelease = latestRelease
        // }else if (closestRelease && !latestRelease &&  !futureRelease){
        //     finalRelease = closestRelease
        // }else if (!closestRelease && !latestRelease &&  futureRelease){
        //     finalRelease = ""
        // }else if (closestRelease && latestRelease &&  !futureRelease){
        //     finalRelease = latestRelease
        // }else if (closestRelease && !latestRelease &&  futureRelease){
        //     finalRelease = closestRelease
        // }else if (closestRelease && latestRelease &&  futureRelease){
        //     finalRelease = latestRelease
        // }

        finalRelease = latestRelease

        


        // let getLatestRelease = releaseList.find(rl => rl.release_date < currentDate)

        console.log("finalRelease",finalRelease)

        return (
            <div className="">
                <div className="component-title list-group" id="working-area">
                    <div className="list-group-item list-group-item-action gradient-background">
                        <div className="" id="endpoint-label-wrapper">
                            <div className="float-left breadcrumbs">
                                <div className="">
                                    <p>
                                        <Link to={'/'}><i className="fas fa-th"></i></Link>
                                        <i className="fas fa-arrow-right"></i>
                                        <Link to={`/${this.breadCrumb()[3]}`}>
                                           About
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <CSSTransition
                        in={true}
                        appear={true}
                        timeout={500}
                        classNames="fade"
                    >
                        {   // do not render if ACLs are still fetching
                            !this.props.initialized ? (
                                <div id="working-area-content" className="working-area-content-about">
                                    <div className="form-area-wrapper-about">
                                        <div className="image-container-about">
                                        <img 
                                            src="https://hris-sandbox.s3-us-west-2.amazonaws.com/eym_io_logo.png"
                                            alt="new"
                                            style={{height:"75px"}}
                                        />

                                        <h3>Version{finalRelease && finalRelease.version}</h3>
                                        </div>

                                    <ReactQuill
                                        value={finalRelease && finalRelease.notes != "" ? finalRelease.notes  : ""}
                                        theme={"bubble"}
                                        placeholder={"Add Changelog"}
                                        readOnly={true}
                                    />
                                    </div>
                                </div>
                            ) : <div></div> 
                        }
                    </CSSTransition>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
   return {
        endpoints: state.endpoints,
        main: state.main,
        auth: state.auth,
        messageBox: state.messageBox
    }
}

export default withRouter(connect(mapStateToProps)(ReleaseNoteForm))


// WEBPACK FOOTER //
// ./src/components/releaseNotes/releaseNotesForm.js